import {jsx} from 'panel';
import last from 'lodash/last';

import {StringOperator} from 'common/widgets/property-filter-menu/models/types';
import {PropertyValuesScreenEl} from 'common/widgets/property-filter-menu/property-values-screen';
import {SelectTheme} from 'common/components/select/constants';
import {SelectEl} from 'common/components/select';
import {CommitPropertyFilterEvent} from 'common/widgets/property-filter-menu/property-values-screen/types';

import {FilterValueProps} from '../types';

const NO_VALUE_OPERATORS = new Set<StringOperator>([StringOperator.Set, StringOperator.NotSet]);

export function FilterStringValue({
  filter,
  isActive,
  onChange,
  onSelectMenuChange,
  eventNames,
  projectId,
  workspaceId,
  readonly,
  hasNewUI,
}: FilterValueProps) {
  return (
    // set and not set do not require a filter value input
    !NO_VALUE_OPERATORS.has(filter.filterOperator as StringOperator) && (
      <SelectEl
        class={{
          'is-placeholder': !filter.isValid(),
        }}
        attrs={{
          elref: `filterValueSelect`,
          open: isActive,
          theme: hasNewUI ? SelectTheme.Tertiary : SelectTheme.Select,
          'never-show-caret': true,
          'selected-option': filter.isValid() ? filter.getValuesLabel() : `Select value…`,
          readonly,
        }}
        on={{
          menuChange: (ev) => onSelectMenuChange(ev),
        }}
      >
        {isActive && (
          <PropertyValuesScreenEl
            attrs={{
              elref: `filterValue`,
              slot: `body`,
              'display-value-only': true,
              'event-names': eventNames,
              'property-filter': filter.getAttributes(),
              'project-id': projectId,
              'workspace-id': workspaceId,
            }}
            params={{
              listProperty: last(filter.getParents()),
            }}
            on={{
              commitPropertyFilter: (ev: CommitPropertyFilterEvent) => onChange(ev.detail.propertyFilter.filterValue),
            }}
          />
        )}
      </SelectEl>
    )
  );
}
